// Router state survives a reload but not a typed URL, so /oauth/done reads it
// as a maybe and treats anything else as a direct visit.

export interface DoneState {
  kind: "connected" | "cancelled";
  clientName: string;
  redirectUrl: string;
}

export function readDoneState(state: unknown): DoneState | null {
  if (!state || typeof state !== "object") return null;
  const s = state as Record<string, unknown>;
  if (s.kind !== "connected" && s.kind !== "cancelled") return null;
  if (typeof s.clientName !== "string" || typeof s.redirectUrl !== "string") {
    return null;
  }
  return { kind: s.kind, clientName: s.clientName, redirectUrl: s.redirectUrl };
}
